import React from 'react';

import { Box, Typography, Divider } from '@mui/joy';
import { observer } from 'mobx-react-lite';

import ResponsiveLayout from '../components/layout/ResponsiveLayout';
import CommandList from '../components/MissionPlanner/CommandList';
import GeoFenceEditor from '../components/MissionPlanner/GeoFenceEditor';
import MissionTools from '../components/MissionPlanner/MissionTools';
import PlannerMap from '../components/MissionPlanner/PlannerMap';
import RallyEditor from '../components/MissionPlanner/RallyEditor';
import ToolSettingsPanel from '../components/MissionPlanner/ToolSettingsPanel';
import ToolsPanel from '../components/MissionPlanner/ToolsPanel';
import { missionPlannerStore } from '../stores/MissionPlannerStore';

const MissionPlanner: React.FC = () => (
  <ResponsiveLayout>
    <Box className='w-full h-full flex border '>
      {/* Vertical Icon Toolbar */}
      <Box sx={{ width: 'auto', borderRight: 1, borderColor: 'divider' }}>
        <ToolsPanel />
      </Box>

      {/* Main Sidebar for Settings and Commands */}
      <Box
        sx={{
          width: 280,
          borderRight: 1,
          borderColor: 'divider',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto'
        }}
      >
        {missionPlannerStore.mode === 'Mission' && (
          <>
            <MissionTools />
            <Divider />
            <ToolSettingsPanel />
            <Divider sx={{ my: 2 }} />
            <Box sx={{ px: 2, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
              <Typography level='title-md' sx={{ mb: 1 }}>
                Mission Commands
              </Typography>
              <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
                <CommandList />
              </Box>
            </Box>
          </>
        )}

        {missionPlannerStore.mode === 'GeoFence' && <GeoFenceEditor />}
        {missionPlannerStore.mode === 'Rally Point' && <RallyEditor />}
      </Box>

      {/* Map Area */}
      <Box sx={{ flex: 1, position: 'relative' }}>
        <PlannerMap />
      </Box>
    </Box>
  </ResponsiveLayout>
);

export default observer(MissionPlanner);
